import styled from 'styled-components';
import type { ITransientMediaAlignment } from '@klv/organisms/two-column/types';

export const GridMedia = styled.div<ITransientMediaAlignment>`
${({ theme, $mediaAlignment }) => `
  grid-column: 1 / -1;
  grid-row: 2;
  margin-bottom: 3.2rem;
  ${theme.screenSize.s768.mediaQuery} {
    grid-column: ${$mediaAlignment === 'right' ? '7 / -1' : '1 / 7'};
    grid-row: 1 / span 4;
  }
`}
`;

export const PricingCustomGridMedia = styled(GridMedia)<ITransientMediaAlignment>`
  display: none;
  ${({ theme }) => `
    ${theme.screenSize.s768.mediaQuery} {
      display: grid;
    }
  `}
`;

export default PricingCustomGridMedia;
